import { store } from "../store";
import { handleUnauthorizedError } from "./apiMiddleware";

const getAuthHeader = (): Record<string, string> => {
  const token = store.getState().user?.currentUser?.token;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const baseUrl = import.meta.env.VITE_API_URL || "http://localhost:5050/api";

const api = {
  get: async (url: string) => {
    const response = await fetch(`${baseUrl}${url}`, {
      headers: getAuthHeader(),
    });
    if (handleUnauthorizedError(response)) throw new Error("Session expirée");
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Erreur HTTP: ${response.status}`);
    }
    return response.json();
  },
  post: async (url: string, body: any) => {
    const response = await fetch(`${baseUrl}${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(body),
    });
    if (handleUnauthorizedError(response)) throw new Error("Session expirée");
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Erreur HTTP: ${response.status}`);
    }
    return response.json();
  },
  put: async (url: string, body: any) => {
    const response = await fetch(`${baseUrl}${url}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(body),
    });
    if (handleUnauthorizedError(response)) throw new Error("Session expirée");
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Erreur HTTP: ${response.status}`);
    }
    return response.json();
  },
  delete: async (url: string) => {
    const response = await fetch(`${baseUrl}${url}`, {
      method: 'DELETE',
      headers: getAuthHeader(),
    });
    if (handleUnauthorizedError(response)) throw new Error("Session expirée");
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Erreur HTTP: ${response.status}`);
    }
    return response.json();
  }
};

export default api;
